<template>
  <div id="app" class="color-bg-1">
    <div class="title color-text-0">深色模式使用指南</div>
    <div class="format describe color-text-2">
      有道词典为安卓用户适配了深色模式，目前仅支持系统版本为Android10及以上的手机设备。
    </div>
    <div class="title-brand color-text-1">
      华为手机开启方式
    </div>
    <div class="format huaweiStep color-text-2">
      第一步：打开手机 「设置」，点击 「显示和亮度」
    </div>
    <div class="photo photo-normal">
      <img src="@/assets/pic_huaweistepone.png" alt="" />
    </div>
    <div class="format huaweiStep color-text-2">
      第二步：选择「深色模式」
    </div>
    <div class="photo photo-normal">
      <img src="@/assets/pic_huaweisteptwo.png" alt="" />
    </div>
    <div class="format huaweiStep color-text-2">
      第三步：开启「深色模式」- 关闭「网易有道词典」
    </div>
    <div class="photo photo-last">
      <img src="@/assets/pic_huaweistepthree.png" alt="" />
    </div>
    <div class="title-brand color-text-1">
      小米手机开启方式
    </div>
    <div class="format xiaomiStep color-text-2">
      第一步：打开手机 「设置」，点击「显示」
    </div>
    <div class="photo photo-normal">
      <img src="@/assets/pic_xiaomistepone.png" alt="" />
    </div>
    <div class="format xiaomiStep color-text-2">
      第二步：选择「深色模式」- 开启「深色模式」
    </div>
    <div class="photo photo-first">
      <img src="@/assets/pic_xiaomisteptwoone_1.png" alt="" />
    </div>
    <div class="photo photo-normal">
      <img src="@/assets/pic_xiaomisteptwotwo.png" alt="" />
    </div>
    <div class="format xiaomiStep color-text-2">
      第三步：选择下方的「设置应用的深色模式」- 开启「网易有道词典」
    </div>
    <div class="photo photo-first">
      <img src="@/assets/pic_xiaomistepthreeone.png" alt="" />
    </div>
    <div class="photo photo-last">
      <img src="@/assets/pic_xiaomistepthreetwo.png" alt="" />
    </div>
    <div class="title-other color-text-1">
      其他手机开启方式
    </div>
    <div class="format otherStep color-text-2">
      在手机「设置」中开启「深色模式」，开启后词典将自动适配
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  created() {
    window.addEventListener("YDUIStyleChange", function (param) {
      if (param.detail === "dark") {
        document.body.classList.add("dark");
      } else {
        document.body.classList.add("light");
      }
    });
    window.setYDUIStyle(
      navigator.userAgent.indexOf("YDUIStyle/Dark") > -1 ? "dark" : "light"
    );
  },
};
</script>

<style scoped>
#app {
  overflow: hidden;
}
.title{
  margin: 0.32rem 0.4rem 0.68rem 0.4rem;
  font-size: 0.48rem;
  font-weight: 600;
}
.format {
  text-align: left;
  line-height: 0.48rem;
}
.describe {
  margin: 0rem 0.4rem 0.7rem 0.4rem;
  font-size: 0.32rem;
}
.title-brand {
  margin: 0rem 0.4rem 0.16rem 0.4rem;
  font-size: 0.36rem;
  line-height: 0.54rem;
  font-weight: bold;
}
.huaweiStep {
  margin: 0rem 0.4rem 0.24rem 0.4rem;
  font-size: 0.32rem;
}
.photo {
  margin-top: 0rem;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  border-radius: 0.28rem;
}
.photo > img {
  width: 100%;
}
.photo-normal {
  margin-bottom: 0.58rem;
}
.photo-first {
  margin-bottom: 0.28rem;
}
.photo-last {
  margin-bottom: 0.82rem;
}
.xiaomiStep {
  margin: 0rem 0.4rem 0.24rem 0.4rem;
  font-size: 0.32rem;
}
.title-other {
  margin: 0rem 0.4rem 0.16rem 0.4rem;
  font-size: 0.36rem;
  line-height: 0.54rem;
  font-weight: bold;
}
.otherStep {
  margin: 0rem 0.4rem 1.90rem 0.4rem;
  font-size: 0.32rem;
}
@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px){
  #app {
  margin-left: 0.448rem;
  margin-right: 0.448rem;
}
}
</style>
